import clientAxios from "../../client";

export async function checkoutPlan(account_id: string, payload: any) {
  return await clientAxios.post(`account/${account_id}/checkout/plan`, payload);
}
